var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownloadGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "#DDDDDD"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Activity",
    clipPath: "url(#clip0_2805_23413)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 2916,
    transform: "translate(-1188 -502)",
    fill: "#F4F7FB"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Funding Block"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 7228"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle Copy 117",
    x: -297.5,
    y: -221.5,
    width: 519,
    height: 323,
    rx: 9.5,
    fill: "white",
    stroke: "#DDDDDD"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group 8123"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 7830"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 5101"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 2241",
    x: -6,
    y: -5,
    width: 86,
    height: 22,
    rx: 3,
    fill: "#EEF7EA"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.99652 7.64746V10.3887H1.61158V7.64746H0V11.1945C0 11.6392 0.360264 11.9998 0.806991 11.9998H10.8011C11.2474 11.9998 11.6081 11.6396 11.6081 11.1945V7.64746H9.99652Z",
    fill: "#57AC2D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M5.65411 7.3758L3.34682 4.58776C3.34682 4.58776 2.99577 4.25632 3.37645 4.25632C3.75712 4.25632 4.6766 4.25632 4.6766 4.25632C4.6766 4.25632 4.6766 4.03335 4.6766 3.6895C4.6766 2.70918 4.6766 0.925077 4.6766 0.197745C4.6766 0.197745 4.62496 0 4.92278 0C5.223 0 6.53796 0 6.75292 0C6.96748 0 6.96267 0.166522 6.96267 0.166522C6.96267 0.871839 6.96267 2.71759 6.96267 3.66588C6.96267 3.97331 6.96267 4.17266 6.96267 4.17266C6.96267 4.17266 7.70001 4.17266 8.16275 4.17266C8.62469 4.17266 8.27683 4.51971 8.27683 4.51971C8.27683 4.51971 6.3138 7.12562 6.04 7.39902C5.84305 7.59716 5.65411 7.3758 5.65411 7.3758Z",
    fill: "#57AC2D"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2805_23413"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 2916,
    fill: "white",
    transform: "translate(-1188 -502)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadGreen);
export default __webpack_public_path__ + "static/media/download-green.37be613301579f801ae45ca133172d8b.svg";
export { ForwardRef as ReactComponent };